<script setup>
import axios  from "axios";
import Alert from "@/components/common/Alert.vue";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="temp"
        width="700px"
    >
        <v-card
            width="700px"
        >
            <v-toolbar
                height="50px"
                flat
                color="#E13532"
                dark
            >
                <v-toolbar-title>
                    テンプレート一覧
                </v-toolbar-title>
                <v-spacer />
                <v-icon
                    @click="temp=false"
                    dark
                >
                    mdi-close
                </v-icon>
            </v-toolbar>
            <v-card-text class="py-1 px-1">
                <v-radio-group
                  v-model="selected_temp_id"
                  column
                >

                <v-list width="100%" v-if="templist.length!=0">
                    <v-list-item v-for="item in templist" :key="item.id" class="my-1">
                        <v-card width="100%">
                            <v-card-text class="py-0">
                            <v-row class="my-0">
                                <v-col cols="1" class="pr-0">
                                    <v-radio
                                        color="red"
                                        :value="item.id"
                                        @click="set_temp"
                                    ></v-radio>
                                </v-col>
                                <v-col cols="7">
                                    <span class="favname">{{ item.name }}</span>
                                </v-col>
                                <v-col >
                                    <span style="font-weight:bold">{{ item.kind }}</span>
                                </v-col>
                                    <v-col
                                        cols="1"
                                        v-if="item.kind!='ディフォルト'"
                                    >
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-on="on"
                                            v-bind="attrs"
                                            class="mr-3"
                                            :id="item.id"
                                            @click="del(item.id)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                        </template>
                                        <span>削除</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            </v-card-text>
                        </v-card>
                    </v-list-item>
                </v-list>
                <Alert messagetitle="お気に入り段落は登録されていません" message="定型段落をお気に入りに登録してリリースを効率的に作成できます。" v-else />
                </v-radio-group>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data () {
        return {
            temp : false,
            templist : [],
            selected_temp_id : "",
        };
    },
    computed : {
        temp_id : {
            set(newValue){
                this.$store.commit("doc_info/set_temp_id",newValue);
            },
            get(){
                return this.$store.getters["doc_info/get_temp_id"];
            },
        },
    },
    methods : {
        set_temp : function(){
            this.temp_id=this.selected_temp_id;
        },
        open : function(){
            this.selected_temp_id = this.temp_id;
            this.getlist();
        },
        getlist : async function(){
            var params = new URLSearchParams();
            await axios.post("/api/release/get_template_list",params)
            .then(response => {
                this.templist = response.data;
                if(this.temp == false)
                    this.temp = true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        del : async function(id){
            var params = new URLSearchParams();
            params.append("id",id);
            await axios.post("/api/release/del_template",params)
            .then(response => {
                this.templist = response.data;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },

    },
    created : function(){
    },
}
</script>
